import { State } from "../../../vendor_core/core/src/states/State";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import ConsoleUtil from "../../../vendor_core/core/src/utils/ConsoleUtil";
import Layer from "../../../vendor_core/core/src/utils/Layer";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import SpineAnimation from "../../../vendor_core/core/src/views/SpineAnimation";
import BitmapTextField from "../../../vendor_core/core/src/views/components/BitmapTextField";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import BURSpinModel from "../models/BURSpinModel";
import BURFeatureModel from "../models/BURFeatureModel";
import App from "../../../vendor_core/core/src/App";
import { BitmapText } from "pixi.js";
import { BitmapMoneyField } from "../../../vendor_core/core/src/views/BitmapMoneyField";
import BURReelsModel from "../models/BURReelsModel";
import BURJackpotsModel from "../models/BURJackpotsModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import { GameLayers } from "../enums/GameLayers";

export default class BUREnterFreespinState extends State {
    //@ts-ignore
    protected scene: SceneView;
    //@ts-ignore
    private popupsLayer: Layer;
    //@ts-ignore
    private bannerLayer: Layer;
    private hasSpineAnimation: boolean = false;
    private introAnimation: SpineAnimation | undefined;

    public async enter() {
        super.enter();
        this.popupsLayer = ViewManager.getLayer(DefaultLayers.Popups);
        this.bannerLayer = ViewManager.getLayer(DefaultLayers.Banners);
        this.scene = this.popupsLayer.setScene("freespinssummary");
        const betBar = ViewManager.getLayer(
            DefaultLayers.BetBar
        ).getCurrentScene();

        SpinModel.enterFreespins();
        // Prevent fs intro screen from showing again
        BURFeatureModel.setWillFreeSpinsTrigger(false);
        // Set the reelset index
        BURReelsModel.setReelsetIndex(
            BURFeatureModel.free_spins_data!.reelSetIndex
        );
        // Set the current free spin index
        BURSpinModel.setCurrentFreeSpinIndex(0);

        // Temporarily hide the free spins counter because it overlaps with the spin button on portrait
        ViewManager.getLayer(DefaultLayers.FreespinCounter).visible = false;

        if (
            BURFeatureModel.free_spins_data!.combo.find((c) => c === "Yellow")
        ) {
            this.initJackpotPlates();
        }

        // Hide the fs total win
        const freespinCount = this.scene.sceneMoneyFields.get(
            "value"
        ) as BitmapMoneyField;
        freespinCount.visible = false;

        if (this.scene.spineAnimations?.has("freespinsIntroOutro")) {
            this.hasSpineAnimation = true;
            this.introAnimation = this.scene.spineAnimations.get(
                "freespinsIntroOutro"
            );
        }

        // Add the free spins won amount in the middle of the fs intro anim
        const freeSpinsWon = new BitmapText(
            BURFeatureModel.free_spins_data!.countFreeSpins.toLocaleString(),
            {
                fontName: "jackpot_font",
                letterSpacing: -50,
                fontSize: 186
            }
        );

        freeSpinsWon.anchor.set(0.5);

        this.introAnimation?.addChild(freeSpinsWon);

        const fsNumberBone = this.introAnimation?.skeleton.findBone(
            "number_text_preview"
        );

        const tickerCallback = () => {
            freeSpinsWon.transform.setFromMatrix(fsNumberBone!.matrix);
            freeSpinsWon.scale.y = -freeSpinsWon.scale.y;
        };

        App.instance.ticker.add(tickerCallback);

        // Play fs intro animation
        this.scene.interactive = true;
        if (this.hasSpineAnimation) {
            this.introAnimation
                ?.playAsync(
                    Layout.isLandscape() ? "intro_start" : "intro_start_pt"
                )
                .then(() => {
                    this.introAnimation?.play(
                        Layout.isLandscape() ? "intro_loop" : "intro_loop_pt",
                        true
                    );

                    // Hide controller and bet buttons
                    betBar.groups.get("controller")!.visible = false;
                    betBar.groups.get("bet_info")!.visible = false;
                });
        }

        this.scene.orientationChangeCallback = () => {
            this.introAnimation?.play(
                Layout.isLandscape() ? "intro_loop" : "intro_loop_pt",
                true
            );
        };

        this.scene.once(PointerEvents.DOWN, async () => {
            this.introAnimation
                ?.playAsync(Layout.isLandscape() ? "intro_end" : "intro_end_pt")
                .then(() => {
                    UIController.setState(UIStates.FREE_SPINS);
                    SoundController.playSound("congrats_end");
                    const hasBannerFreespinsScene: boolean =
                        this.bannerLayer.hasScene("freespins");
                    this.popupsLayer.clear();
                    if (hasBannerFreespinsScene) {
                        const bannerScene: SceneView = ViewManager.getLayer(
                            DefaultLayers.Banners
                        ).setScene("freespins");
                        if (bannerScene.sceneTextFields?.get("anouncer")) {
                            let announcer = bannerScene.sceneTextFields.get(
                                "anouncer"
                            ) as BitmapTextField;
                            announcer.visible = false;
                        } else {
                            ConsoleUtil.warn(
                                "[PSD] Missing announcer component for EnterFreeSpinsState"
                            );
                        }
                    }
                    CommandManager.execute(
                        Commands.UPDATE_FREE_SPINS,
                        BURFeatureModel.free_spins_data!.countFreeSpins.toString()
                    );
                    SoundController.playMusic(SoundVars.MUSIC_BONUS);
                    this.scene.destroy();

                    // Clear the free spins won
                    App.instance.ticker.remove(tickerCallback);
                    this.introAnimation?.removeChild(freeSpinsWon);
                    freeSpinsWon.destroy();

                    // Show the free spins announcer
                    ViewManager.getLayer(
                        DefaultLayers.FreespinCounter
                    ).visible = true;

                    // Exit
                    this.exit();
                });
        });
    }

    // The logo is in the way of the jackpot plates on portrait only
    private updateLogoVisibility() {
        ViewManager.getLayer(DefaultLayers.Banners).visible =
            Layout.isLandscape();
    }

    private initJackpotPlates() {
        // Init the jackpot plates
        const jackpotScene = ViewManager.getLayer(
            GameLayers.JackpotPlates
        ).setScene("open");

        // The plates are over the logo on portrait. On landscape they are below it, so it stays. The scene is
        // destroyed when the free spins end, so its callback does not outlive them.
        this.updateLogoVisibility();
        jackpotScene.orientationChangeCallback = () =>
            this.updateLogoVisibility();

        // Add the win amount on each jackpot plate
        BURJackpotsModel.jackpot_tiers.forEach((tier) => {
            const plate = ViewManager.getLayer(GameLayers.JackpotPlates)
                .getCurrentScene()
                .spineAnimations.get(`${tier.toLowerCase()}JackpotPlate`)!;
            const currency = BetModel.currency;
            const currentBet = BetModel.totalBet;
            const jpWinAmount = Number(
                BURJackpotsModel.jackpots_config![tier].value * currentBet
            ).toFixed(currency.decimals);
            const prize = new BitmapText(`${currency.symbol}${jpWinAmount}`, {
                fontName: "jackpot_font",
                fontSize: 48,
                letterSpacing: -50
            });

            prize.anchor.set(0.5);

            // Attach to the number bone
            const numberBone = plate.skeleton.findBone(
                `${tier.toLowerCase()}_number`
            )!;
            prize.transform.setFromMatrix(numberBone.matrix);

            // Force the width to fit inside the designated space
            if (prize.width > 180) {
                prize.scale.set(180 / prize.width);
                prize.y *= 180 / prize.width;
            }

            // The numberBone flips the number upside down
            // Setting scale.y to -1 fixes that
            prize.scale.y = -prize.scale.y;

            plate.addChild(prize);
        });
    }
}
